<template>
  <div class="Journalism">
    <div class="Journalism_nav">
      <div class="Journalism_one">
        <div class="Journalism_onetop">
          <div class="Journalism_xian1"></div>
          <div class="Journalism_xian2"></div>
          <div v-for="(item,index) in title" :key="index" class="Journalism_txt" v-if="index<2" @click="dian(item.zt,item.id)" :class="item.zt?'addtxt':''">
            {{item.txt}}
            <div class="Journalism_xian3" v-if="index<1"></div>
          </div>
          <div class="Journalism_right" @click="jump1">
            <div class="zi">MORE></div>
          </div>
        </div>
        <div class="Journalism_onebottom">
          <div class="Journalism_list" @click="jump()">
            <img src="/src/assets/tu1.jpg" class="Journalism_listl"/>
            <div class="Journalism_listr">
               <div class="a">“线上会议|“乐享我术”2020年 肝胆胰外科手术视频</div>
               <div class="listr_xia">
                 <span style="margin-right: 20px;">来源：消化快报</span>
                 <span>2020/12/14</span>
               </div>
            </div>
          </div>
          <div v-for="(item,index) in title2" :key="index" class="Journalism_list2" v-if="index<3">
            <div class="Journalism_list2id">{{item.id}}</div>
            <div class="Journalism_list2txt"><span style="margin-right: 10px;font-weight: bold;">{{item.txt1}}</span>{{item.txt}}</div>
          </div>
        </div>
      </div>
      <div class="Journalism_one">
        <div class="Journalism_onetop">
          <div class="Journalism_xian1"></div>
          <div class="Journalism_xian2"></div>
          <div v-for="(item,index) in title3" :key="index" class="Journalism_txt" v-if="index<2" @click="dian2(item.zt,item.id)" :class="item.zt?'addtxt':''">
            {{item.txt}}
            <div class="Journalism_xian3" v-if="index<1"></div>
          </div>
          <div class="Journalism_right" @click="jump1">
            <div class="zi">MORE></div>
          </div>
        </div>
        <div class="Journalism_onebottom">
          <div class="Journalism_list" @click="jump()">
            <img src="/src/assets/tu2.jpg" class="Journalism_listl"/>
            <div class="Journalism_listr">
               <div class="a">“线上会议|“乐享我术”2020年 肝胆胰外科手术视频</div>
               <div class="listr_xia">
                 <span style="margin-right: 20px;">来源：消化快报</span>
                 <span>2020/12/14</span>
               </div>
            </div>
          </div>
          <div v-for="(item,index) in title2" :key="index" class="Journalism_list2" v-if="index<3">
            <div class="kandian">【看点】</div>
            <div class="Journalism_list2txt"><span style="margin-right: 10px;font-weight: bold;">{{item.txt1}}</span>{{item.txt}}</div>
          </div>
        </div>
      </div>
      <div class="Journalism_two">
        <div class="Journalism_twotop">
          <div class="Journalism_twotopl">
            <div class="Journalism_xian1"></div>
            <div class="Journalism_xian2"></div>
            <div class="Journalism_txt" style="font-weight: bold;font-size: 20px;">活动报告</div>
          </div>
          <div class="Journalism_twotopr">
            <div class="fudong">
              <div class="zuo" @click="left" @mouseover="xuan(1)" @mouseout="xuan(2)" :class="jia?'addxuan':''"><</div>
              <div class="you" @click="right" @mouseover="xuan2(1)" @mouseout="xuan2(2)" :class="jia2?'addxuan':''">></div>
            </div>
          </div>
        </div>
        <div>
        <el-carousel trigger="click" indicator-position="none" :autoplay="zidong" style="overflow-y: hidden;" ref="car" @change="changeFun">
          <el-carousel-item class="Journalism_twobottom" v-for="(item,index) in iconsArr" :key="index">
            <img :src="item.src" class="baodaotu"/>
            <div class="baodaotxt">{{item.name}}</div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

 export default {
  data () {
    return {
      iconsArr: [
        {
          id: 1,
          name: '开幕式环节由陈志宇教授主持',
          src: 'https://uniappfile.boyuancb.com/Res/BosihuiwenRes/20201217140727.jpg'
        },
        {
          id: 2,
          name: '开幕式环节由陈志宇教授主持',
          src: 'https://uniappfile.boyuancb.com/Res/BosihuiwenRes/20201217140727.jpg'
        },
        {
          id: 3,
          name: '开幕式环节由陈志宇教授主持',
          src: 'https://uniappfile.boyuancb.com/Res/BosihuiwenRes/20201217140727.jpg'
        }
      ],
      zuo: false,
      you: true,
      zidong: true,
      jia: false,
      jia2: false,
      title:[
        {
          id: 1,
          txt: '最新资讯'
        },
        {
          id: 2,
          txt: '最新资讯2'
        },
        {
          id: 3,
          txt: '最新资讯3'
        },
      ],
      title3:[
        {
          id: 1,
          txt: '业内资讯'
        },
        {
          id: 2,
          txt: '业内资讯2'
        },
        {
          id: 3,
          txt: '业内资讯3'
        },
      ],
      title2:[
        {
          id: 1,
          txt1: '线上会议|',
          txt: '“乐享我术”2020年肝胆胰外科手术视频'
        },
        {
          id: 2,
          txt1: '会议动态|',
          txt: '“乐享我术”2020年肝胆胰外科手术视频'
        },
        {
          id: 3,
          txt1: '消化外科云学院|',
          txt: '——菁英在线第三期胃外科专场成功举办'
        }
      ],
    }
  },methods:{
    //初始化页面
    index(){
      for(var i=0;i<this.title.length;i++){
        if(i==0){
          this.title[i].zt = true;
          this.title.push('1');
          this.title.pop('1');
        }else{
          this.title[i].zt = false;
          this.title.push('1');
          this.title.pop('1');
        }
      }
      for(var i=0;i<this.title3.length;i++){
        if(i==0){
          this.title3[i].zt = true;
          this.title3.push('1');
          this.title3.pop('1');
        }else{
          this.title3[i].zt = false;
          this.title3.push('1');
          this.title3.pop('1');
        }
      }
    },
    //标题点击事件
    dian(zt,id){
      if(!zt){
        for(var i=0;i<this.title.length;i++){
          if(id==this.title[i].id){
            this.title[i].zt = true;
            this.title.push('1');
            this.title.pop('1');
          }else{
            this.title[i].zt = false;
            this.title.push('1');
            this.title.pop('1');
          }
        }
      }
    },
    dian2(zt,id){
      if(!zt){
        for(var i=0;i<this.title3.length;i++){
          if(id==this.title3[i].id){
            this.title3[i].zt = true;
            this.title3.push('1');
            this.title3.pop('1');
          }else{
            this.title3[i].zt = false;
            this.title3.push('1');
            this.title3.pop('1');
          }
        }
      }
    },
    jump(){
      this.$router.push({path:'/expert_details'});
    },
    //最新资讯更多
    jump1(){
      this.$router.push({path:'/consulting'});
    },
    //轮播图上一页
    left(){
      if(this.zuo){
        this.$refs.car.prev();
      }
    },
    //轮播图下一页
    right(){
      if(this.you){
        this.$refs.car.next();
      }
    },
    //控制翻页按钮样式改变
    changeFun(e){
      console.log(e,'e')
      var num = this.iconsArr.length;
      if(num==1){
        this.zuo = false;
        this.you = false;
      }else if(e==num-1){
        this.zuo = true;
        this.you = false;
      }else if(e==0){
        this.zuo = false;
        this.you = true;
      }
    },
    //悬停箭头停止自动滚动
    xuan(id){
      if(id==1){
        this.zidong = false;
        this.jia = true;
      }else{
        this.zidong = true;
        this.jia = false
      }
    },
    //悬停箭头停止自动滚动
    xuan2(id){
      if(id==1){
        this.zidong = false;
        this.jia2 = true;
      }else{
        this.zidong = true;
        this.jia2 = false
      }
    }
  },created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
.Journalism{
    width: 100%;
    min-width: 1200px;
    background-color: #FFFFFF;
	.Journalism_nav{
		width: 85%;
		margin: 0 auto;
		overflow: hidden;
    margin-top: 36px;
		.Journalism_one{
			width: 40%;
			float: left;
			.Journalism_onetop{
				width: 100%;
				overflow: hidden;
        border-bottom: 2px solid #EEEEEE;
				.Journalism_xian1{
					width: 4px;
					height: 21px;
					background: var(--xt);
					float: left;
          margin-right: 4px;
          margin-top: 7px;
				}
				.Journalism_xian2{
					width: 2px;
					height: 21px;
					background: var(--xt);
					float: left;
          margin-right: 12px;
          margin-top: 7px;
				}
				.Journalism_txt{
					width: 24%;
          cursor: pointer;
					font-size: 18px;
					font-family: Source Han Sans SC;
					font-weight: 400;
					color: #000000;
					line-height: 38px;
					position: relative;
          text-align: center;
          float: left;
					.Journalism_xian3{
            width: 2px;
            height: 16px;
            background: #EEEEEE;
						position: absolute;
						right: 0;
            top: 14px;
					}
				}
				.Journalism_right{
					float: right;
					width: 90px;
					height: 12px;
					font-size: 14px;
					font-family: Source Han Sans SC;
					font-weight: bold;
					color: #878787;
					line-height: 23px;
          cursor: pointer;
          .zi{
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #878787;
            line-height: 23px;
            margin-right: 9px;
            margin-top: 8px;
          }
				}
			}
      .Journalism_onebottom{
         width: 100%;
         overflow: hidden;
         margin-top: 19px;
        .Journalism_list{
          width: 100%;
          overflow: hidden;
          margin-bottom: 26px;
          .Journalism_listl{
            width: 40%;
            height: 119px;
            float: left;
            cursor: pointer;
          }
          .Journalism_listl:hover{
            transform: scale(1.05);
          }
          .Journalism_listr{
            width: 53%;
            float: left;
            margin-left: 2%;
            .a{
              font-size: 18px;
              cursor: pointer;
              font-family: Adobe Heiti Std;
              font-weight: bold;
              text-decoration: underline;
              line-height: 28px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .a:hover{
              color: var(--xt)!important;
            }
           .listr_xia{
             margin-top: 35px;
             span{
               font-size: 14px;
               font-family: Adobe Heiti Std;
               font-weight: normal;
               color: #757575;
               line-height: 28px;
             }
           }
          }
        }
        .Journalism_list2{
          width: 100%;
          overflow: hidden;
          margin-bottom: 22px;
          .Journalism_list2id{
            width: 5%;
            max-width: 20px;
            height: 20px;
            background: #E34919;
            border-radius: 50%;
            text-align: center;
            line-height: 20px;
            float: left;
            margin-right: 15px;
            color: #FFFFFF;
            margin-left: 2%;
          }
          .kandian{
            line-height: 20px;
            float: left;
            font-size: 16px;
            font-family: Adobe Heiti Std;
            font-weight: bold;
            color: #000000;
            margin-right: 10px;
          }
          .Journalism_list2txt{
            width: 80%;
            font-size: 16px;
            line-height: 20px;
            font-family: Adobe Heiti Std;
            color: #000000;
            float: left;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow:hidden;
            cursor: pointer;
          }
        }
      }
    }
    .Journalism_two{
      width: 20%;
      float: left;
      .Journalism_twotop{
      	width: 100%;
      	overflow: hidden;
        border-bottom: 2px solid #EEEEEE;
        .Journalism_twotopl{
          width: 70%;
          float: left;
          .Journalism_xian1{
          	width: 4px;
          	height: 21px;
          	background: var(--xt);
          	float: left;
            margin-right: 4px;
            margin-top: 7px;
          }
          .Journalism_xian2{
          	width: 2px;
          	height: 21px;
          	background: var(--xt);
          	float: left;
            margin-right: 12px;
            margin-top: 7px;
          }
          .Journalism_txt{
          	font-size: 18px;
          	font-family: Source Han Sans SC;
          	font-weight: 400;
          	color: #000000;
          	line-height: 38px;
          }
        }
        .Journalism_twotopr{
          width: 30%;
          float: left;
          overflow: hidden;
          margin-top: 3px;
          .fudong{
            width: 55px;
            float: right;
            margin-top: 5px;
             .zuo,.you{
               width: 20px;
               height: 20px;
               line-height: 20px;
               text-align: center;
               border: 1px solid #C49444;
               margin-right: 10px;
               float: left;
               color: var(--xt);
               cursor: pointer;
             }
             .you{
               margin-right: 0;
             }
          }
        }
      }
      /deep/ .el-carousel__arrow{
        display: none;
      }
      .Journalism_twobottom{
        width: 100%;
        padding-top: 19px;
        cursor: pointer;
        .baodaotu{
          width: 100%;
          height: 199px;
          margin-bottom: 21px;
        }
        .baodaotu:hover{
          transform: scale(1.05);
        }
        .baodaotxt{
          width: 100%;
          text-align: center;
          font-size: 18px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #000000;
          line-height: 23px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow:hidden;

        }
      }
    }
  }
}
.addtxt{
  font-weight: bold!important;
  font-size: 20px!important;
}
.addxuan{
  background: var(--xt)!important;
  border: 1px solid var(--xt)!important;
  color: #FFFFFF!important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/home/Journalism.vue